import axios from 'axios';
import { format } from 'date-fns';
import { DHLError, handleHttpResponse, axiosRequest } from '@general/js/utils';
import Services from '@general/js/services/Services';
import AbstractClass from './HomePageAbstractServices';

export default class HomePageServices extends AbstractClass {
  // For getting public website reference data
  static async getPWReferenceData() {
    try {
      const response = await axios.get(Services.HOMEPAGE_PW.GET_REFERENCE_DATA);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getPWReferenceData() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  static async getMaintenanceReferenceData() {
    try {
      const response = await axios.get(Services.HOMEPAGE_PW.GET_MAINTENANCE_DATA);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getMaintenanceReferenceData() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  // For getting member portal reference data
  static async getMPReferenceData() {
    try {
      const response = await axios.get(Services.HOMEPAGE_MP.GET_REFERENCE_DATA);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getMPReferenceData() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  // Get membership info
  static async getMembershipInfo(memberNumber, dropdown = false) {
    const isInvalidMemberNumber = (number) => {
      const invalidValues = ['not-selected', 'undefined', '$memberNumber$'];
      return invalidValues.includes(number);
    };

    if (!memberNumber || isInvalidMemberNumber(memberNumber)) {
      throw new Error("getMembershipInfo() - Current member number is invalid!");
    }

    const currentDate = format(new Date(), 'yyyy-MM-dd');
    try {
      const response = await axiosRequest().get(Services.HOMEPAGE_MP.GET_MEMBERSHIP_INFO(memberNumber), {
        params: {
          currentDate,
          dropdown, // Dropdown when navigation menu is opened or not
        },
      });
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getMembershipInfo() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
